import { render, staticRenderFns } from "./DatatableModal.vue?vue&type=template&id=18deb320&"
import script from "./DatatableModal.vue?vue&type=script&lang=js&"
export * from "./DatatableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports